<template>
    <component :is="componentType" v-bind="$attrs" @click="handleClick">
        <slot></slot>
    </component>
</template>

<script setup>
import { Link } from "@inertiajs/vue3";
import { isInIFrame, openUrl } from "~vue/utils";
import { logError } from "~vue/utils/logUtils";
import { useAttrs } from "vue";

const attrs = useAttrs();

// Returns the Inertia Link component unless we're in an iFrame (MS Teams) or the method is not GET
const getComponentType = () => {
    if (!isInIFrame() || (attrs.method && attrs.method.toLowerCase() !== "get")) {
        return Link;
    }
    return "button";
};

const componentType = getComponentType();

const handleClick = () => {
    if (componentType === Link) {
        if (!attrs.href) {
            // log an error for missing href prop for now, and use this to fallback to the openUrl util
            // in the future typescript will catch prop related issues
            logError("BaseLink.vue: 'href' attribute is required for Inertia Link.");
            openUrl(attrs.href, { queryParams: attrs.data });
        }
    } else {
        openUrl(attrs.href, { queryParams: attrs.data });
    }
};
</script>
